
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { any, arrayOf, bool, oneOf, oneOfType, string } from "prop-types";

const SingleRoute = ({
  accessible, component: Component, type, ...rest
}) => {
  const user = useSelector((store) => store.user.user);

  if (!user && type === "private") {
    return <Redirect to='/' from={rest.path} />;
  }

  if (user && !user.holdForBusinessInfo && type === "public") {
    return <Redirect to='/home' from={rest.path} />;
  }

  return (
    <Route
      path={rest.path}
      component={Component}
      {...rest}
    />
  );
};

SingleRoute.propTypes = {
  accessible: bool,
  component: any.isRequired,
  exact: bool.isRequired,
  path: oneOfType([arrayOf(string).isRequired, string.isRequired]).isRequired,
  title: string.isRequired,
  type: oneOf(["public", "private", "error"]).isRequired,
};

SingleRoute.defaultProps = { accessible: null };

export default SingleRoute;
